<form class="ngb-table">
  <div class="form-group form-inline">
    Full text search: <input class="form-control ms-2" type="text" name="searchTerm" [(ngModel)]="service.searchTerm"/>
    @if (service.loading$ | async) {
      <span class="ml-3">Loading...</span>
    }
  </div>

  <div class="table-responsive">
    <table class="table table-striped border ">
      <thead>
        <tr>
          <th scope="col">S.No</th>
          <th scope="col" sortable="name" (sort)="onSort($event)">Country</th>
          <th scope="col" sortable="area" (sort)="onSort($event)">Area</th>
          <th scope="col" sortable="population" (sort)="onSort($event)">Population</th>
        </tr>
      </thead>
      <tbody>
        @for (country of countries$ | async; track country) {
          <tr>
            <th scope="row">{{ country.id }}</th>
            <td>
              <img [src]="'https://upload.wikimedia.org/wikipedia/commons/' + country.flag" class="me-2" style="width: 20px">
              <ngb-highlight [result]="country.name" [term]="service.searchTerm"></ngb-highlight>
            </td>
            <td><ngb-highlight [result]="country.area | number" [term]="service.searchTerm"></ngb-highlight></td>
            <td><ngb-highlight [result]="country.population | number" [term]="service.searchTerm"></ngb-highlight></td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-between p-2">
    <ngb-pagination
      [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize">
    </ngb-pagination>
    <ng-select class="" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
      <ng-option ng-option-selected value="0">--Select--</ng-option>
      <ng-option value="5">5 items</ng-option>
      <ng-option value="10">10 items</ng-option>
      <ng-option value="50">50 items</ng-option>
      <ng-option value="100">100 items</ng-option>
    </ng-select>
  </div>

</form>